module.exports = __webpack_public_path__ + "img/92.8567dc3f.jpg";